// extracted by mini-css-extract-plugin
export default {"footer":"useDynamicOverlay_footer__6wePJ","modalMobile":"useDynamicOverlay_modalMobile__3ZFNb"};